import React, {Fragment} from 'react';
import {Helmet} from 'react-helmet';
import StoryList from './story-list/index.jsx';

const MyStories = () => (
  <Fragment>
    <Helmet>
      <title>My stories</title>
    </Helmet>
    <StoryList own />
  </Fragment>
);

export default MyStories;
